import React from 'react';
import styled from 'styled-components';
import { Form, Col, Button, Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { nl2br } from 'helpers';
import { lang } from 'lang';
import { convertTimestampToDate } from 'helpers';
import { validType } from 'const';

/**
 * アカウントフォームコンポーネント
 */
const AccountForm = (props) => {
  const { isUpdate, values, onSubmit, register, formState, errors } = props;
  const { validate, word } = lang;
  const validationMsg = {
    name: {               // 名前
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 40),
    },
    email: {              // Eメール
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 256),
      pattern: validate.incorrect.replace('%s', word.mail_address),
      validate: validate.not_apply,
    },
    phone_number: {       // 外線直通電話番号
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 20),
      pattern: validate.phone_number_pattern,
    },
    preferred_username: { // 所属
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 100),
    },
  };
  // Eメールのドメインを検証する
  const validationDomain  = (email) => {
    if (process.env.REACT_APP_MAIL_DOMAIN !== '*') {
      const match = '@(' + process.env.REACT_APP_MAIL_DOMAIN + ')$';
      const re = new RegExp(match);
      // ドメイン部が定義済ドメイン以外
      if (!email.match(re)) {
        return false;
      }  
    }
    return true;
  };
  // エラーメッセージをレンダリングする
  const renderMessage = (key, type) => {
    const text = validationMsg[key][type];
    return (
      <Form.Group as={Col} md="12" className='form-group_alert'>
        {text && <Alert variant='warning' >{nl2br(text)}</Alert> }
      </Form.Group>
    );
  };
  return (
    <Form onSubmit={onSubmit}>
      <Form.Group as={Col} md="6">
        <Form.Label htmlFor='name'>Name<Span>(Mandatory)</Span></Form.Label>
        <Form.Control
          id='name'
          type='text'
          name='name'
          maxLength={40}
          className={errors.name ? 'input-warning' : ''}
          defaultValue={isUpdate ? values.name : ''}
          ref={
            register({ 
              required: true,
              maxLength: 40,
            })
          }
        >
        </Form.Control>
      </Form.Group>
      {errors.name && renderMessage('name', errors.name.type)}
      <Form.Group as={Col} md="10">
        <Form.Label  htmlFor='preferred_username'>Organization<Span>(Mandatory)</Span></Form.Label>
        <Form.Control 
          id='preferred_username'
          type='text'
          name='preferred_username'
          maxLength={100}
          className={errors.preferred_username ? 'input-warning' : ''}
          defaultValue={isUpdate ? values.preferred_username : ''}
          ref={
            register({ 
              required: true,
              maxLength: 100,
            })
          }
        >
        </Form.Control>
      </Form.Group>
      {errors.preferred_username && renderMessage('preferred_username', errors.preferred_username.type)}
      {!isUpdate && (<Form.Group as={Col} md="10">
        <Form.Label htmlFor='email'>E-mail<Span>(Mandatory)</Span></Form.Label>
        <Form.Control
          id='email'
          type='email'
          name='email'
          maxLength={256}
          className={errors.email ? 'input-warning' : ''}
          defaultValue={isUpdate ? values.email : ''}
          ref={
            register({ 
              required: true,
              maxLength: 256,
              pattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]{0,63}@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/,
              validate: validationDomain,
            })
          }
        >
        </Form.Control>
      </Form.Group>)}
      {(!isUpdate && errors.email) && renderMessage('email', errors.email.type)}
      <Form.Group as={Col} md="10">
        <Form.Label htmlFor='phone_number'>Phone number<Span>(Mandatory)</Span></Form.Label>
        <Form.Control
          id='phone_number'
          type='text'
          name='phone_number'
          maxLength={20}
          className={errors.phone_number ? 'input-warning' : ''}
          defaultValue={isUpdate ? values.phone_number : '+'}
          ref={
            register({ 
              required: true,
              maxLength: 20,
              pattern: /^\+[0-9]+$/
            })
          }
        >
        </Form.Control>
      </Form.Group>
      {errors.phone_number && renderMessage('phone_number', errors.phone_number.type)}
      {isUpdate &&
        <Form.Group as={Col} md="10">
          <Table striped bordered hover>
            <tbody>
              <tr>
                <td>sub ID</td>
                <td>{values.sub}</td>
              </tr>
              <tr>
                <td>E-mail</td>
                <td>{values.email}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>{validType[values.enabled]}</td>
              </tr>
              <tr>
                <td>Verification</td>
                <td>{values.user_status}</td>
              </tr>
              <tr>
                <td>Created Date</td>
                <td>{convertTimestampToDate(values.created_at)}</td>
              </tr>
              <tr>
                <td>Last Update</td>
                <td>{convertTimestampToDate(values.updated_at)}</td>
              </tr>
            </tbody>
          </Table>
        </Form.Group>
      }
      <SubmitButton
        data-testid='submit-button'
        type='submit'
        disabled={formState.isSubmitting}
      >
        {isUpdate ? 'Update' : 'Add'}
      </SubmitButton> 
    </Form>
  );
};
AccountForm.propTypes = {
  isUpdate: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  formState: PropTypes.object,
  onSubmit: PropTypes.func,
  register: PropTypes.func,
};
AccountForm.defaultProps = {
  isUpdate: false,
  values: {},
};
const SubmitButton = styled(Button)`
  margin-left: 5px;
  margin-bottom: 20px;

`;
const Span = styled.span`
  color: red;
  margin-left:10px;
`;
export default AccountForm;